// src/index.js — FULL DROP-IN (service worker disabled to stop stale cache)
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ IMPORTANT: Disable service worker during debugging.
// If an old SW is controlling the site, it can keep serving old JS that still uses fetch().
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  });
}
